var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', [!_vm.noContent ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addBtnLoading
    },
    on: {
      "click": function click($event) {
        return _vm.addOrUpdateHandle();
      }
    }
  }, [_vm._v("Add Office Address")]) : _vm._e()], 1), _c('div', {
    staticClass: "el-list protocols-wrapper"
  }, [_c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    attrs: {
      "gutter": 30
    }
  }, [_vm.noContent ? _c('el-col', [_c('el-empty', {
    attrs: {
      "description": " "
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.addOrUpdateHandle();
      }
    }
  }, [_vm._v("Add Office Address")])], 1)], 1) : _vm._e(), !_vm.noContent ? _vm._l(_vm.dataList, function (item) {
    var _item$supplier;

    return _c('el-col', {
      key: item.id,
      attrs: {
        "span": 6
      }
    }, [_c('el-card', {
      staticClass: "mt16 relative",
      attrs: {
        "shadow": "nerver",
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('div', {
      staticClass: "module-item"
    }, [_c('div', {
      staticClass: "module-desc"
    }, [_c('p', {
      staticClass: "item-wrap"
    }, [_c('span', {
      staticClass: "wd86 item-label"
    }, [_vm._v("Entity type:")]), _c('span', {
      staticClass: "item-content"
    }, [_vm._v(" " + _vm._s(_vm.entityTypes.find(function (el) {
      return el.value == item.type;
    }).title ? _vm.entityTypes.find(function (el) {
      return el.value == item.type;
    }).title : "") + " ")])]), _c('p', {
      staticClass: "item-wrap"
    }, [_c('span', {
      staticClass: "wd86 item-label"
    }, [_vm._v(_vm._s(_vm.isMultiLineAddressCountry(item.country) ? "Address 1:" : "Address:"))]), _c('span', {
      staticClass: "item-content"
    }, [_vm._v(_vm._s(_vm.isMultiLineAddressCountry(item.country) ? item.addressLine1 : item.address))])]), _c('p', {
      staticClass: "item-wrap"
    }, [_c('span', {
      staticClass: "wd86 item-label"
    }, [_vm._v("Country:")]), _c('span', {
      staticClass: "item-content"
    }, [_vm._v(_vm._s(_vm.countryFormat(item.country)))])]), _c('p', {
      staticClass: "item-wrap"
    }, [_c('span', {
      staticClass: "wd86 item-label"
    }, [_vm._v("Supplier:")]), _c('span', {
      staticClass: "item-content"
    }, [_vm._v(_vm._s(((_item$supplier = item.supplier) === null || _item$supplier === void 0 ? void 0 : _item$supplier.abbr) || ""))])]), _c('p', {
      staticClass: "item-wrap"
    }, [_c('span', {
      staticClass: "wd86 item-label"
    }, [_vm._v("Update:")]), _c('span', {
      staticClass: "item-content"
    }, [_vm._v(_vm._s(item.updateTime))])])])]), _c('ul', {
      staticClass: "el-card-actions"
    }, [_c('li', {
      staticStyle: {
        "width": "50%"
      },
      on: {
        "click": function click($event) {
          return _vm.deleteHandle(item.id);
        }
      }
    }, [_c('svg-icon', {
      staticClass: "fs16",
      attrs: {
        "name": "delete"
      }
    })], 1), _c('li', {
      staticStyle: {
        "width": "50%"
      },
      on: {
        "click": function click($event) {
          return _vm.addOrUpdateHandle(item);
        }
      }
    }, [_c('svg-icon', {
      staticClass: "fs16",
      attrs: {
        "name": "edit"
      }
    })], 1)])])], 1);
  }) : _vm._e()], 2)], 1), _c('add-or-update', {
    ref: "addOrUpdate",
    attrs: {
      "supplierList": _vm.supplierList
    },
    on: {
      "refreshDataList": _vm.getDataList
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }